// extracted by mini-css-extract-plugin
export default {"project-info-container":"ProjectViewInfo_project-info-container__Lw8+a"};